<main>
  @if (session?.learner) {
    <div class="wrapper">
      <header translate [translateParams]="{ name: session.learner?.name }">
        session-retake-request-form.component.greeting
      </header>

      <p>{{ pluralizedTranslationFor('description') }}</p>

      @if (retakeRequest) {
        <div class="retakes">
          <lv-session-retake-request-form-item
            [retakeRequest]="retakeRequest"
            [session]="session"
            photoType="face"
            (photoTaken)="onPhotoTaken($event)"
          ></lv-session-retake-request-form-item>

          <lv-session-retake-request-form-item
            [retakeRequest]="retakeRequest"
            [session]="session"
            photoType="id"
            (photoTaken)="onPhotoTaken($event)"
          ></lv-session-retake-request-form-item>
        </div>
      }
    </div>
  }
</main>

<footer>
  @if (session) {
    <button
      [disabled]="!facePhotoReady || !idPhotoReady"
      type="button"
      (click)="onSubmit()"
      class="button is-primary is-medium"
    >
      {{ pluralizedTranslationFor('submit') }}
    </button>
  }
</footer>
